import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Pinyin.css";

function Pinyin() {
  const [userGrade, setUserGrade] = useState(null); // Stores detected grade

  // Simulated function to get the user’s age and convert it to grade
  useEffect(() => {
    const userAge = parseInt(localStorage.getItem("userAge"), 10); // Simulated stored age
    if (userAge && userAge >= 6 && userAge <= 18) {
      setUserGrade(userAge - 5); // Grade = Age - 5 (Assumption: Grade 1 starts at Age 6)
    }
  }, []);

  // Generates the list of grades (If userGrade exists, show only that grade)
  const gradeList = userGrade
    ? [<Link key={userGrade} to={`/ChineseSubject/Pinyin/Grade${userGrade}`}  className="Pinyin-grade-card">Grade {userGrade}</Link>]
    : [...Array(12)].map((_, index) => (
        <Link key={index + 1} to={`/ChineseSubject/Pinyin/Grade${index + 1}`} className="Pinyin-grade-card">
          Grade {index + 1}
        </Link>
      ));

  return (
    <div className="play2learn-Pinyin">
      <h1 className="Pinyin-title">Pinyin Lessons</h1>
      <p className="Pinyin-description">
        {userGrade ? `Showing content for Grade ${userGrade}/Grade${userGrade}Pinyin` : "Select a grade to start learning:"}
      </p>

      {/* Grade Selection */}
      <div className="Pinyin-grade-container">
        {gradeList}
      </div>
    </div>
  );
}

export default Pinyin;
